import Quill from 'quill';

const BlockEmbed = Quill.import("blots/block/embed");
const ATTACHMENT_WRAPPER_STYLE = `
    // display: flex;
    // flex-direction: row;
    // align-items: center;
    // padding: 10px;
    // background-color: #F8F9FB;
    // border-radius: 4px;
    // color: white;
    border: 1px solid rgb(235 240 248);
    // width: 100%;
    // margin-bottom: 8px;
    margin-top: 8px;
    box-shadow: 0px 1px 2px rgba(45, 52, 63, 0.2);

    display: flex;
    flex-direction: column;
  `;

const TRASH_ICON_SVG = `
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_617_9)">
      <path
        d="M16.875 4.375H3.125"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.125 8.125V13.125"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.875 8.125V13.125"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.625 4.375V16.25C15.625 16.4158 15.5592 16.5747 15.4419 16.6919C15.3247 16.8092 15.1658 16.875 15 16.875H5C4.83424 16.875 4.67527 16.8092 4.55806 16.6919C4.44085 16.5747 4.375 16.4158 4.375 16.25V4.375"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.125 4.375V3.125C13.125 2.79348 12.9933 2.47554 12.7589 2.24112C12.5245 2.0067 12.2065 1.875 11.875 1.875H8.125C7.79348 1.875 7.47554 2.0067 7.24112 2.24112C7.0067 2.47554 6.875 2.79348 6.875 3.125V4.375"
        stroke="#667182"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_617_9">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

const PENCIL_ICON_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M7.5 16.8749H3.75C3.58424 16.8749 3.42527 16.8091 3.30806 16.6919C3.19085 16.5747 3.125 16.4157 3.125 16.2499V12.7577C3.12472 12.6766 3.14044 12.5962 3.17128 12.5211C3.20211 12.446 3.24745 12.3778 3.30469 12.3202L12.6797 2.94524C12.7378 2.88619 12.8072 2.83929 12.8836 2.80728C12.9601 2.77527 13.0421 2.75879 13.125 2.75879C13.2079 2.75879 13.2899 2.77527 13.3664 2.80728C13.4428 2.83929 13.5122 2.88619 13.5703 2.94524L17.0547 6.42962C17.1137 6.48777 17.1606 6.5571 17.1927 6.63355C17.2247 6.71 17.2411 6.79205 17.2411 6.87493C17.2411 6.95781 17.2247 7.03987 17.1927 7.11632C17.1606 7.19277 17.1137 7.26209 17.0547 7.32024L7.5 16.8749Z" stroke="#667182" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M16.875 16.875H7.5" stroke="#667182" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10.625 5L15 9.375" stroke="#667182" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

class HTMLEmbedBlot extends BlockEmbed {
  static tagName: string;
  static blotName: string;
  static className: string;
  static id: string;
  static html: string;
  static icon: string;

  static create(options: { id: number; html: string; icon: string }) {
    const { id, html, icon } = options;
    this.id = id + "HTML-EMBED";
    this.html = html;
    this.icon = icon;

    const node = super.create();
    if (id) {
      this.attachmentHTML(node);
      node.setAttribute("id", this.id);
      node.style = ATTACHMENT_WRAPPER_STYLE;
    }

    return node;
  }

  static value(node: { getAttribute: (arg0: string) => any }) {
    return node.getAttribute("src");
  }

  static attachmentHTML(element: HTMLIFrameElement) {
    const html = `
      <style>
        .embedbody {
          border: 1px solid var(--border-color-primary);
          border-radius: 4px;
          margin-right: 9px;
          padding-right: 3px;
        }

        .embedheader {
          background: #F8F9FB;
          border-radius: 4px 4px 0px 0px;
          padding: 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .embedheader > div {
          display: flex;
          align-items: center;
        }

        .pencilLogo {
            display: flex;
            cursor: pointer;
        }

        .deletIcon {
            display: flex;
            cursor: pointer;
        }

        .embedheadertext {
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 17px;
          color: #11294F;
          display: flex;
          padding-right: 8px;
          margin-left: 14px;
        }
        .embedfooter {
          display: flex;
          justify-content: flex-end;
          background: white;
          padding: 7px;
        }
      </style>
      <div class="embedheader">
        <div>
          ${this.attachmentIconHTML()}
          <span class="embedheadertext">HTML</span>
          <span onclick="
          function handler() {
              const node = document.getElementById('${this.id}');
              node.dataset.activeHtmlEmbed = 'true';
              const htmlEmbed = document.querySelector('.ql-htmlembed');
              htmlEmbed.click();
              document.querySelector('.embedBodyInput').value = node.dataset.embeddedHtml;
          }

          handler();" class="pencilLogo">${PENCIL_ICON_SVG}</span>
        </div>
        <span onclick="
        function handler() {
            const node = document.getElementById('${this.id}');
            node.parentNode.removeChild(node);
        }

        handler();" class="deletIcon">${TRASH_ICON_SVG}</span>
      </div>
      `;

    element.setAttribute("id", this.id.toString());
    element.dataset.embeddedHtml = this.html;
    element.innerHTML = html;
  }

  static attachmentIconHTML() {
    return `<img src="${this.icon}" />`;
  }
}

HTMLEmbedBlot.tagName = "div";
HTMLEmbedBlot.blotName = "htmlembed";
HTMLEmbedBlot.className = "htmlembed";

export default HTMLEmbedBlot;
